import {
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from "react-native";
import { Colors, Spacing, Typography } from "../../styles";

interface Props {
  title: string;
  onPress: () => void;
  textColor?: string;
  borderColor?: string;
  style?: ViewStyle;
  icon?: React.ReactNode;
}

const Button = ({
  title,
  onPress,
  textColor = Colors.white,
  borderColor = Colors.white,
  style,
  icon,
}: Props) => {
  return (
    <TouchableOpacity onPress={onPress}>
      <View style={[styles.button, { borderColor }, style]}>
        <Text style={[Typography.paragraph, { color: textColor }]}>
          {title}
        </Text>
        {icon && <View style={styles.icon}>{icon}</View>}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderWidth: 1,
    borderRadius: Spacing.cardRadius / 2,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
  icon: { marginLeft: 6 },
});

export default Button;
